import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button } from 'reactstrap';
import { WellsStore } from 'src/Stores/Wells/WellsStore';



@inject('stores')
@observer
class EButton extends React.Component {
    public props: any;
    private ErrorStore: any;
    private WellsStore: WellsStore;
    private buttonDisabled: boolean = false;
    public errorsDisposer: any;
    public eoDisposer: any;

    public state = {
        buttonDisabled: this.buttonDisabled
    };

    constructor(props: any) {
        super(props);

        this.ErrorStore = this.props.stores.ErrorsStore;
        this.WellsStore = props.stores.WellsStore;
    }

    public componentDidMount() {
        this.disableEnableButton();
        
        this.errorsDisposer = observe(this.ErrorStore, 'errorObject', (change: any) => {
            this.disableEnableButton();

            return change;
        });

        this.eoDisposer = observe(this.ErrorStore, 'errors', (change: any) => {
            this.disableEnableButton();

            return change;
        });
    }

    public disableEnableButton() {
        let buttonDisabled: boolean = true;
        const allErrorsCleared = this.ErrorStore.allErrorsCleared();
        
        if ( allErrorsCleared ) {
            buttonDisabled = false;
        }
        this.setState({
            buttonDisabled
        });

    }

    public componentWillUnmount() {
        this.errorsDisposer();
        this.eoDisposer();
    }

    public render() {
        const currWell = this.WellsStore.well;
        const disableWellStatus = currWell !== undefined && currWell.wellStatus !== 'Active' &&  currWell.wellStatus !== 'Finishing' && !this.props.location.pathname.includes('wellclose');
        const { staticContext, ...propsToPass } = this.props;
        return(
            <Button {...propsToPass} disabled={disableWellStatus || this.state.buttonDisabled || this.props.disabled}>{this.props.children}</Button>
        );
    }
}

export default withRouter(EButton);


// WEBPACK FOOTER //
// ./src/Components/EInput/EButton.tsx